if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let content = this.innerHTML;

      // Regex für Tabellenblock
      let tableRegex = /\[table-start\]([\s\S]*?)\[table-end\]/g;

      // Ersetze jeden Tabellenblock durch gerenderte <table>
      this.innerHTML = content.replace(tableRegex, (match, tableContent) => {
        // Zeilen anhand von <br> splitten
        let rows = tableContent.split(/<br>|<br\/>|\n/g).map(r => r.trim()).filter(r => r.length > 0);

        // Wenn keine sinnvollen Zeilen -> Block einfach löschen
        if (rows.length === 1) {
          return "";
        }

        let tableHTML = `<table class="nutritional-table">`;

        rows.forEach((row, j) => {
          let cols = row.split("|");

          if (j === 0) {
            // Erste Zeile = Header
            tableHTML += `<thead><tr>`;
            cols.forEach(col => {
              tableHTML += `<th>${col.trim()}</th>`;
            });
            tableHTML += `</tr></thead><tbody>`;
          } else {
            // Normale Zeilen
            tableHTML += `<tr>`;
            cols.forEach(col => {
              let isIndented = col.includes("=");
              tableHTML += `<td class="${isIndented ? "cell-indent" : ""}">${col.replace("=", "").trim()}</td>`;
            });
            tableHTML += `</tr>`;
          }
        });

        tableHTML += `</tbody></table>`;
        return tableHTML;
      });
    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
  }
}